import { modifierString, type PreviewModifier } from "./index";

function textModifier(
    apply: (value: string, args: unknown[]) => string,
): PreviewModifier {
    return {
        types: ["string", "list"],
        apply: (value, args) => {
            const text = modifierString(value);
            return text === undefined ? value : apply(text, args);
        },
    };
}

const uppercase = textModifier((value) => value.toUpperCase());
const lowercase = textModifier((value) => value.toLowerCase());

export const textModifiers: Record<string, PreviewModifier> = {
    uppercase,
    upper: uppercase,
    lowercase,
    lower: lowercase,
    title_case: textModifier(
        (value) =>
            (Array.from(value)[0]?.toUpperCase() ?? "") +
            Array.from(value).slice(1).join(""),
    ),
    capitalise: textModifier((value) =>
        value
            .toLowerCase()
            .replace(
                /(^|[^\p{L}\p{N}'’])(\p{L})/gu,
                (_, prefix, char) => prefix + char.toUpperCase(),
            ),
    ),
    trim: textModifier((value) =>
        value.replace(/^[ \n\r\t\v\0]+|[ \n\r\t\v\0]+$/g, ""),
    ),
    trim_start: textModifier((value) => value.replace(/^[ \n\r\t\v\0]+/g, "")),
    trim_end: textModifier((value) => value.replace(/[ \n\r\t\v\0]+$/g, "")),
    append: textModifier(
        (value, args) => value + (modifierString(args[0]) ?? ""),
    ),
    prepend: textModifier(
        (value, args) => (modifierString(args[0]) ?? "") + value,
    ),
    concat: textModifier(
        (value, args) =>
            value + args.map((arg) => modifierString(arg) ?? "").join(""),
    ),
    combine: textModifier(
        (value, args) =>
            value + args.map((arg) => modifierString(arg) ?? "").join(""),
    ),
    replace: textModifier((value, args) => {
        const search = modifierString(args[0]);
        return search
            ? value.replaceAll(search, () => modifierString(args[1]) ?? "")
            : value;
    }),
};
